export default __webpack_public_path__ + "static/media/YellowTimerIcon.b061ff33.svg";